import video from "../../images/mobile.gif"
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


// import required modules
import { Navigation,EffectFade, Pagination,Autoplay, Mousewheel, Keyboard } from 'swiper/modules';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { alert } from "../../redux/actions/alert"
import SignIn from "../../pages/auth/signIn"
import { Helper } from "../../functionality/helper";
import { apiRoutes } from "../../functionality/apiRoutes";

function Intro() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const information = [{
        hint:"Complete your joy. Register today!",
        des:"Discover a hassle-free shopping experience. Buy what you want, the easy way!",
        image:"",
        buttonTitle:"Sign In",
        action:()=>{
            dispatch(alert({
                isOpen :true,
                component : <SignIn/>
            }))
        }
    },{
        hint:"Shop Anywhere !",
        des:"Shop from any location, and we’ll deliver your orders quickly and conveniently.",
        image:"",
        buttonTitle:"Start",
        action:()=>{
            navigate("/items")
        }
    },{
        hint:"Offers You'll Love!",
        des:"Stay updated on the latest shipping discounts and enjoy top quality service.",
        image:"",
        buttonTitle:"Discover",
        action:()=>{
            navigate("/items")
        }
    }]
    const [data, setData] = useState([])
    const [loading, setLoading]= useState(0)
    useEffect(()=>{
        const controller = new AbortController()
        const signal = controller.signal
        const getSliders = async (signal)=>{
            setLoading(true)
            const {response , message} = await Helper({
                url : apiRoutes.home.getSlider,
                method : "GET",
                signal
            })
            if(response){
                
                setData(response.data)
                setLoading(false)
            }
        }
        getSliders(signal)
        return () => controller.abort()
    },[])
 
    


    
    return ( <div className="">
        
            <div  className="md:h-96 flex justify-between md:flex-row flex-col-reverse px-5 md:px-10  lg:px-24 items-center">

                <div className="w-full md:w-1/2  " >
                {loading? <div className='min-h-96 dynamic-pages w-full flex justify-center items-center'>
 
                    <div className="bounce"></div>
                    <div className="bounce"></div>
                    <div className="bounce"></div>

                    </div> : <Swiper
                        cssMode={true}
                        navigation={false}
                        autoplay={{ delay: 2500, disableOnInteraction: false }}
                        pagination={false}
                        mousewheel={true}
                        loop={true}
                        slidesPerView={1}
                        modules={[Navigation,Autoplay, Pagination]}
                        className="mySwiper "
                    
                        >
                        
                        {
                            data.map((item,index)=>(<SwiperSlide key={item.name+index}>
                                <div dangerouslySetInnerHTML={{__html : item.content?item.content:""}} />
                            </SwiperSlide>))
                        }
                        
                        </Swiper>}
                
                  
                    
                </div>
                <div className="h-full flex justify-end md:w-1/2">
                        <div className=" h-full flex justify-end">
                                 <img className="h-full object-containt img-hero" alt="easy marketing" src={video}  />
                                 {/* <video   autoPlay muted loop   src={video} /> */}
                        </div>
                    
                </div>


                </div>
    
    
    </div>);
}

export default Intro;


// complete_your_joy
{/* <div class="w-full "><span class="hidden  md:block">Complete your joy. Register today!</span><h1 class=" my-4 text-center md:text-start md:block">Discover a hassle-free shopping experience. Buy what you want, the easy way!</h1><div class="flex justify-center md:block"><button>Sign In</button></div></div> */}
// shop_anywhere
{/* <div class="w-full "><span class="hidden  md:block">Shop Anywhere !</span><h1 class=" my-4 text-center md:text-start md:block">Shop from any location, and we’ll deliver your orders quickly and conveniently.</h1><div class="flex justify-center md:block"><button>Start</button></div></div> */}
// offers_you'll_love
{/* <div class="w-full "><span class="hidden  md:block">Offers You'll Love!</span><h1 class=" my-4 text-center md:text-start md:block">Stay updated on the latest shipping discounts and enjoy top quality service.</h1><div class="flex justify-center md:block"><button>Discover</button></div></div> */}